/**
 * 用于构建视频动画系统
 * 依赖pixi 4
 * 依赖TimelineLite.js
 */
export class T9Video {
    // res = [   //资源对象示例
    //     {
    //         resid: '',//资源ID，唯一
    //         resimg: '',//资源封面
    //         resname: '',//资源名称
    //         restype: 1,//资源类型，0为旁白，1为角色，2为挂件,3为商品组件相关
    //         resobj: {},//资源对象
    //         timeline: [ //时间轴
    //             {
    //                 //内部格式比较自由,比包含内容如下
    //                 type: 1,//进度条内容类型,1为讲话，2挂件入场，3移动,4商品组件切换
    //                 dur: 1,//持续时间
    //                 text: "",//文本内容
    //             }
    //         ],
    //         startend: [0, 0], //起止时间，单位秒，0为未设置
    //         nodelete: true, //是否允许移除
    //     }
    // ]
    videoobj = { //视频对象
        scenes: [ //场景集合
            {
                scenetitle: '',
                sceneCover: '', //场景封面
                sceneId: '',
                scene: { url: '' }, //场景对象(背景图片)
                render: {}, //尺寸、灯光、材质、滤镜
                bgm: { name: '', url: '', volume: 100 },//背景音乐
                dur: 0, //总时长
                tran: {}, //过度、转场动画
                height: 720, //场景高度
                width: 1280, //场景宽度
                moshi: 0, //0 横屏 1 竖屏
                res: [

                ], //资源集合
                temp: "light", //主题dark/light


            }
        ],
        bgm: { name: '', url: '', volume: 100 },//总背景音乐
        dur: 0, //视频总时长
    }
    constructor(videoobj) {
        if (videoobj) {
            this.videoobj = videoobj
        }
    }
    /**
     * 向场景中追加事件
     * @param {*} obj 
     * @param {*} scenes 
     */
    timelinepush (resid, obj, scenes = 0) {
        for (var i = 0; i < this.videoobj.scenes[scenes].res.length; i++) {
            if (this.videoobj.scenes[scenes].res[i].resid == resid) {
                // 修改startend会导致任务只显示obj.dur的时间
                // this.videoobj.scenes[scenes].res[i].startend[1] += obj.dur
                this.videoobj.scenes[scenes].res[i].timeline.push(obj)
                break
            }
        }
    }
    /**
     * 向场景中增加资源
     * @param {*} res 资源对象
     * @param {*} type  资源类型，0为旁白，1为角色，2为挂件 6 3d组件
     * @param {*} endtime 为资源结束时间，如果为0，则表示资源持续时间为视频总时长
     * @param {*} scenes 场景索引
     */
    respush (res, type, endtime = 0, scenes = 0) {
        console.log('pushresD Juese ', res)
        if (type == 0 || type == 1) {
            //拼接元素对象
            var obj = {
                // resid: this.res.rolesId,
                // resimg: this.res.rolesPhoto,
                // resname: this.res.rolesName,
                // restype: 1,//资源类型，0为旁白，1为角色，2为挂件
                // resobj: this.res,//资源对象
                resid: res.rolesId,
                resimg: res.rolesPhoto,
                resname: res.rolesName,
                restype: 1,//资源类型，0为旁白，1为角色，2为挂件
                resobj: res,//资源对象
                nodelete: true, //是否允许移除
                // 修改startend会导致任务只显示obj.dur的时间
                startend: [0, 0], //起止时间，单位秒，0为未设置
                // startend: [0, endtime], //起止时间，单位秒，0为未设置
                dotOptions: [{ //滑块禁用
                    disabled: false
                }, {
                    disabled: false
                }],
                timeline: [], //时间轴
            }
            this.videoobj.scenes[scenes].res.push(obj)
        }
        else if (type == 2) {
            //拼接元素对象
            var obj = {
                resid: res.materialId,
                resimg: res.materialPath,
                resname: res.materialName,
                restype: type,
                resobj: res,//资源对象
                // 修改startend会导致任务只显示obj.dur的时间

                // startend: [0, endtime], //起止时间，单位秒，0为未设置
                startend: [0, 0], //起止时间，单位秒，0为未设置
                dotOptions: [{ //滑块禁用
                    disabled: false
                }, {
                    disabled: false
                }],
                timeline: [], //时间轴
            }
            // console.log(obj);
            this.videoobj.scenes[scenes].res.unshift(obj)
        } else if (type == '3d') {
            //拼接元素对象
            var obj = {
                resid: res.materialId,
                resimg: '',
                resname: res.materialName,
                restype: type,
                resobj: res,//资源对象
                // 修改startend会导致任务只显示obj.dur的时间
                // startend: [0, endtime], //起止时间，单位秒，0为未设置
                startend: [0, 0], //起止时间，单位秒，0为未设置
                dotOptions: [{ //滑块禁用
                    disabled: false
                }, {
                    disabled: false
                }],
                timeline: [], //时间轴
            }
            // console.log(obj);

            this.videoobj.scenes[scenes].res.unshift(obj)

        }
        else {
            console.log("未知元素，请检查系统版本")
        }
        // window.t9render.setScene(this.videoobj.scenes[0])
    }
    /**
     * 向场景中增加资源(直播带货业务,接口返回scenes.res scenes为对象)
     * @param {*} res 资源对象
     * @param {*} type  资源类型，0为旁白，1为角色，2为挂件
     * @param {*} endtime 为资源结束时间，如果为0，则表示资源持续时间为视频总时长
     * @param {*} scenes 场景索引
     */
    respushObj (res, type, endtime = 0, scenes = 0) {
        // switch (type) {
        //     case 0 || 1:
        //         //拼接元素对象
        //         var obj = {
        //             resid: res.resid,
        //             resimg: res.resimg,
        //             resname: res.resname,
        //             restype: type,//资源类型，0为旁白，1为角色，2为挂件
        //             resobj: res,//资源对象
        //             nodelete: true, //是否允许移除
        //             startend: [0, endtime], //起止时间，单位秒，0为未设置
        //             dotOptions: [{ //滑块禁用
        //                 disabled: false
        //             }, {
        //                 disabled: false
        //             }],
        //             timeline: [], //时间轴
        //         }
        //         this.videoobj.scenes[scenes].res.push(obj)
        //         break
        //     case 2:
        //         //拼接元素对象
        //     var obj = {
        //         resid: res.materialId,
        //         resimg: res.materialPath,
        //         resname: res.materialName,
        //         restype: type,
        //         resobj: res,//资源对象
        //         startend: [0, endtime], //起止时间，单位秒，0为未设置
        //         dotOptions: [{ //滑块禁用
        //             disabled: false
        //         }, {
        //             disabled: false
        //         }],
        //         timeline: [], //时间轴
        //     }
        //     // console.log(obj);
        //     this.videoobj.scenes.res.push(obj)
        //         break
        //     case 'subtitle':

        if (type == 0 || type == 1) {
            //拼接元素对象
            var obj = {
                resid: this.res.rolesId,
                resimg: this.res.rolesPhoto,
                resname: this.res.rolesName,
                restype: 1,//资源类型，0为旁白，1为角色，2为挂件
                resobj: this.res,//资源对象
                nodelete: true, //是否允许移除
                // 修改startend会导致任务只显示obj.dur的时间

                // startend: [0, endtime], //起止时间，单位秒，0为未设置
                dotOptions: [{ //滑块禁用
                    disabled: false
                }, {
                    disabled: false
                }],
                timeline: [], //时间轴
            }
            this.videoobj.scenes.res.push(obj)
        }
        else if (type == 2) {
            //拼接元素对象
            var obj = {
                resid: res.materialId,
                resimg: res.materialPath,
                resname: res.materialName,
                restype: type,
                resobj: res,//资源对象
                // 修改startend会导致任务只显示obj.dur的时间

                // startend: [0, endtime], //起止时间，单位秒，0为未设置
                dotOptions: [{ //滑块禁用
                    disabled: false
                }, {
                    disabled: false
                }],
                timeline: [], //时间轴
            }
            // console.log(obj);
            this.videoobj.scenes.res.push(obj)
        }
        else {
            console.log("未知元素，请检查系统版本")
        }
    }
    /**
    * 获得资源对象
    * @param {*} id 
    */
    getres (id, scenes = 0) {
        var resobj
        for (var i = 0; i < this.videoobj.scenes[scenes].res.length; i++) {
            if (this.videoobj.scenes[scenes].res[i].resid == id) {
                resobj = this.videoobj.scenes[scenes].res[i]
                break
            }
        }
        return resobj
    }
    /**
     * 在时间轴上查找指定资源的最后位置
     */
    lastpostion (id) {
        var plist = this.gettimeline(id, 3)
        var lastpostion = null //最后的位置
        if (plist.length > 0) {
            lastpostion = JSON.parse(JSON.stringify(plist[plist.length - 1]))
        }
        return lastpostion
    }
    /**
     * 时间轴中第一个位置
     * @param {*} id 
     */
    firstpostion (id) {
        var plist = this.gettimeline(id, 3)
        var lastpostion = null //最后的位置
        if (plist.length > 0) {
            lastpostion = JSON.parse(JSON.stringify(plist[0]))
        }
        return lastpostion
    }

    /**
    * 在时间轴上查找指定资源的某类事件
    * @param {*} tl 时间轴对象
    * @param {*} id 资源ID
    * @param {*} type 事件类型（可选）
    */
    gettimeline (id, type) {
        let newtls = []
        for (let j = 0; j < this.videoobj.scenes.length; j++) { //遍历场景
            var reslist = this.videoobj.scenes[j].res
            for (let x = 0; x < reslist.length; x++) //遍历资源
            {
                if (reslist[x].resid == id) //找到资源
                {
                    var timeline = reslist[x]
                    if (timeline && timeline.timeline) {
                        newtls = timeline.timeline
                        if (type) {
                            newtls = timeline.timeline.filter(item => item.type == type)
                        }
                        else {
                            newtls = timeline.timeline
                        }
                    }
                }
            }

        }
        return newtls
    }

    /**
     * 删除时间轴上的事件
     * @param {*} index 
     */
    deletetl (resid, index) {
        for (let j = 0; j < this.videoobj.scenes.length; j++) { //遍历场景
            var timeline = this.videoobj.scenes[j].res
            for (let x = 0; x < timeline.length; x++) //遍历资源
            {
                if (timeline[x].resid == resid) //找到资源
                {
                    timeline[x].timeline.splice(index, 1)
                }
            }
        }
    }
    /**
     * 删除指定资源的全部时间
     * @param {*} resid 
     */
    deletetl_resid (resid) {
        for (let j = 0; j < this.videoobj.scenes.length; j++) { //遍历场景
            var timeline = this.videoobj.scenes[j].timeline
            for (var i = 0; i < timeline.length; i++) {
                if (timeline[i].user.rolesId == resid) {
                    timeline.splice(i, 1)
                }
            }
        }
    }
    /**
     * 删除场景中的资源
     * @param {*} id 
     * @param {*} scenes 
     */
    deleteres (id, scenes = 0) {
        // 调用方法：this.$set(target, key, value)
        // target：要更改的数据源(可以是对象或者数组)
        // key：要更改的具体数据
        // value ：重新赋的值


        console.log('被移除的元素id', id)
        // console.log(this.videoobj.scenes[scenes].res)
        // debugger
        //未完成
        //删除前，需要验证，是否有事件，提示用户，再删除
        for (var i = 0; i < this.videoobj.scenes[scenes].res.length; i++) {
            if (this.videoobj.scenes[scenes].res[i].resid == id) {
                this.videoobj.scenes[scenes].res.splice(i, 1)
                // this.$set(this.videoobj.scenes[scenes].res, i, null)
                window.t9render.setScene(this.videoobj.scenes[scenes])
                break
            }
        }
    }
    /**
     * 删除场景中的资源(直播带货返回数据scenes为对象)
     * @param {*} id 
     * @param {*} scenes 
     */
    deleteresScene (id, scenes = 0) {
        //未完成
        //删除前，需要验证，是否有事件，提示用户，再删除
        for (var i = 0; i < this.videoobj.scenes.res.length; i++) {
            if (this.videoobj.scenes.res[i].resid == id) {
                this.videoobj.scenes.res.splice(i, 1)
                break
            }
        }
    }

    /**
     * 将指定的资源进行替换
     * @param {*} oldresid 被替换掉的资源ID
     * @param {*} resobj 新的资源对象
     */
    resreplace (oldresid, resobj) {
        //1、先替换资源对象
        for (var z = 0; z < this.this.videoobj.scenes.length; z++) { //遍历场景
            var reslist = this.videoobj.scenes[z].res
            for (var i = 0; i < reslist.res.length; i++) {
                if (reslist.res[i].resid == oldresid) {
                    // var obj ={
                    //     resid: res.materialId,
                    //     resimg: res.materialPath,
                    //     resname: res.materialName,
                    //     restype:type,
                    //     resobj:res//资源对象
                    // }
                    reslist.res[i] = resobj
                    break
                    // resobj = this.videoobj.scenes[scenes].res[i].resobj;
                    // break;
                }
            }

            // 2将时间轴中的资源替换
            var timeline = this.videoobj.scenes[z].timeline
            for (var i = 0; i < timeline.length; i++) {
                if (timeline[i].user.rolesId == oldresid) {
                    timeline[i].user.rolesId = resobj.resid
                    timeline[i].user.rolesName = resobj.resname
                }
            }
        }


    }

    /**
     * 修改资源的起止时间
     * @param {*} resid 
     * @param {*} start 
     * @param {*} end 
     * （修改startend会改变资源的起止时间）
     */
    setresstartend (resid, start, end) {
        for (var z = 0; z < this.videoobj.scenes.length; z++) { //遍历场景
            var reslist = this.videoobj.scenes[z].res
            for (var i = 0; i < reslist.length; i++) {
                if (reslist[i].resid == resid) {
                    reslist[i].startend = [start, end]
                    break
                }
            }
        }
    }


}